import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Marquee from "react-fast-marquee";

import mm1 from '../../img/Home/mm1.png';
import mm2 from '../../img/Home/mm2.png';
import m3 from '../../img/Home/m3.png';
import m4 from '../../img/Home/m4.png';
import m5 from '../../img/Home/m5.png';
import m6 from '../../img/Home/m6.png';
import m7 from '../../img/Home/m7.png';
import m8 from '../../img/Home/m8.png';

function ArvestOffers () {

    const { t } = useTranslation();
      
    return(
        <div className="relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative">
                <div className="flex flex-col items-center">
                    <p className="spantext text-[#0C2780] font-[700] text-[23px] xl:text-[45px] open-sans text-center"><Trans>{t('home.38')}</Trans></p>
                    <p className="text-[17px] xl:text-[19px] font-[600] open-sans text-[#0C2780] text-center">{t('home.39')}</p>
                </div>
            </div>
            <Marquee autoFill className="mt-[50px] xl:mt-[60px]">
                <img src={mm1} alt="" className="px-[15px] xl:px-[40px]"/>
                <img src={mm2} alt="" className="px-[15px] xl:px-[40px]"/>
                <img src={m3} alt="" className="px-[15px] xl:px-[40px]"/>
                <img src={m4} alt="" className="px-[15px] xl:px-[40px]"/>
                <img src={m5} alt="" className="px-[15px] xl:px-[40px]"/>
                <img src={m6} alt="" className="px-[15px] xl:px-[40px]"/>
                <img src={m7} alt="" className="px-[15px] xl:px-[40px]"/>
                <img src={m8} alt="" className="px-[15px] xl:px-[40px]"/>
            </Marquee>
        </div>
    );
}

export default ArvestOffers;